import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { MessageService } from 'src/app/service/common/message.service';
import { InvoiceService } from 'src/app/service/pages/invoice.service';
import { ConfirmDeleteModalComponent } from '../confirm-delete-modal/confirm-delete-modal.component';

   
@Component({
  selector: 'app-view-invoice-modal',
  templateUrl: './view-invoice-modal.component.html',
  styleUrls: ['./view-invoice-modal.component.css']
})
export class ViewInvoiceModalComponent implements OnInit {

  private _subs : Subscription = new Subscription();
  invoice : any;
  update : any;;
  barristerPaymentCheck : boolean;

  constructor(
    private invoiceService : InvoiceService,
    private msgService : MessageService,
    private dialog : MatDialog,
    private dialogRef : MatDialogRef<ViewInvoiceModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) { 
    dialogRef.disableClose = true;
    this.update = false;
    this.barristerPaymentCheck = true;
  }

  ngOnInit(): void {
    this.loadInvoiceDetails();
  }

  loadInvoiceDetails(){
    // console.log(this.data);
    this._subs.add(
      this.invoiceService.getInvoice(this.data.tableName, this.data.id, this.data.caseId).subscribe(res => {
        // console.log(res);
        if(res.status == 'ok'){
          this.invoice = res.data;
        }else{
          this.msgService.error(res.message);
          this.dialogRef.close(null);
        }
      })
    )
  }


  deletePayment(id){
    let config : MatDialogConfig = {
      width : "550px"
    } 
    this.dialog.open(ConfirmDeleteModalComponent, config).afterClosed().subscribe(res => {
      if(res){
        this._subs.add(
          this.invoiceService.removePayment(id, this.data.tableName, res).subscribe(result => {
            if(result.status == 'ok'){
              this.msgService.success(result.message);
              this.loadInvoiceDetails();
              this.update = true;
            }else{
              this.msgService.error(result.message);
            }
          })
        )
      }
    })
  }

  savePayment(form){
    let payment = form.value;
    payment.invoiceId = this.data.id;
    payment.caseId = this.data.caseId;
    payment.tableName = this.data.tableName;
    if(this.barristerPaymentCheck){
      payment.barristerPayment = 1;
    }else{
      payment.barristerPayment = 0;
    }
    this._subs.add(
      this.invoiceService.savePayment(payment).subscribe(res => {
        // console.log(res);
        if(res.status == 'ok'){
          this.msgService.success(res.message);
          this.loadInvoiceDetails();
          form.reset();
          this.update = true;
        }else{
          this.msgService.error(res.message);
        }

      })
    )
  }


  closeModal(){
    this.dialogRef.close(this.update);
  }

  ngOnDestroy(){
    this._subs.unsubscribe();
  }

}
